/**
 * import react
 */
import React from 'react';

/**
 * import material-ui/core
 */
import TabelRow from '@material-ui/core/TableRow';
import TabelCell from '@material-ui/core/TableCell';

const CameraTableHeadRow = () => {
  return (
    <TabelRow>
      <TabelCell padding="none" style={{ padding: 8 }}>Select</TabelCell>
      <TabelCell style={{ textAlign: 'center', padding: 8 }}>Camera</TabelCell>
      <TabelCell padding="none" style={{ textAlign: 'center', padding: 8 }}>Assigned</TabelCell>
    </TabelRow>
  );
};

export default React.memo(CameraTableHeadRow);
